module.exports = __webpack_public_path__ + "static/media/rocky-mountain-elk-foundation.d69ac803.png";